import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla-normas-dialog',
  templateUrl: './tabla-normas-dialog.component.html',
  styleUrls: ['./tabla-normas-dialog.component.scss']
})
export class TablaNormasDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
